<template>
    <b-button
        variant="success"
        @click.stop="download()"
        title="Realiza o download do modelo processado com informações do convênio"
    >
        <span><i class="fa fa-cog"></i> Documento Processado</span>
    </b-button>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'

export default {
    props: {
        modelo: {
            type: Object,
            default: () => ({})
        },

        convenio: {
            type: Object,
            default: () => ({})
        },

        tipoDocumento: {
            type: String
        }
    },

    methods: {
        download() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.downloadDocumento(
                this.$route.params.convenioId,
                this.modelo.modeloId,
                this.tipoDocumento
            ).then(response => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao realizar download do arquivo!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        let codigo = this.convenio.vcCodigoEstruturado.replace(
                            '/',
                            '-'
                        )
                        this.$download(
                            response,
                            `${codigo}_${this.modelo.nomeArquivo}`
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
